export enum MediaType {
  IMAGE = 'image',
  DOCUMENT = 'document',
}
